/* ============================================================
   CAKE ER — Troubleshooting Diagnostic · LAYER'D Cakes
   Static asset: upload once to the theme's assets/ folder.

   Reads the #cker-config JSON island (set server-side by the
   page template), falling back to window.CAKE_ER for older
   templates — safe deploy order is always: this file first.
     src          URL of the JSON to fetch (public, or the full
                  library for premium customers — the template
                  decides; premium = learn-hub-pro OR
                  academy-member tag, resolved by the gate snippet)
     isPremium    true for tagged, logged-in customers (pro OR academy;
                  older templates set isMember — both accepted)
     tier         'visitor' | 'free' | 'pro' | 'academy'
                  (academy-access entries stay locked unless tier==='academy';
                   their lock CTAs point to the Academy, never Toolkit Pro)
     mode         'waitlist' | 'live' (flips the CTA copy/target)
     academyUrl   waitlist page, or the Academy page once live
     proUrl       LAYER’D Toolkit Pro product page (live-mode primary CTA)
     proPrice     display price, e.g. "$79" (may be blank)
     loginUrl     /account/login?return_url=<this tool> (non-premium)
     dowelCalcUrl Dowel calculator page (Brief 02)

   Renders BOTH data shapes: the pre-retrofit public shape (split
   entries carried fix_steps) and the current one (split entries
   carry diagnosis + why; fix_steps + tip exist only in the
   members file). Every field is feature-detected.

   Security note: this file NEVER contains locked content or the
   members file URL. Gating happens at the data level — the public
   JSON simply does not include locked fields.
   ============================================================ */
(function () {
  'use strict';
  /* every viewport move routes through the ONE shared utility
     (nav rule 2026-07-20); absent = no scroll, never a local fallback */
  function ldNav(target, opts) {
    var C2 = window.LAYERD && window.LAYERD.components;
    return !!(C2 && C2.navigateToSection && C2.navigateToSection(target, opts));
  }


  var cfg = (function () {
    var n = document.getElementById('cker-config');
    if (n) { try { return JSON.parse(n.textContent) || {}; } catch (e) { /* fall through */ } }
    return window.CAKE_ER || {};
  })();
  var isPremium = !!(cfg.isPremium || cfg.isMember); // isMember = pre-CO-01 template
  var root = document.getElementById('cker-app');
  if (!root) return;

  var DATA = null;          // { categories:[], entries:[] }
  var byId = {};            // entry id -> entry
  var byCat = {};           // category id -> [entries]
  var catById = {};         // category id -> category

  var SEV = { critical: 'Critical', common: 'Common', cosmetic: 'Cosmetic' };

  /* ---------- tiny DOM helpers ---------- */
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function frag(children) {
    var f = document.createDocumentFragment();
    children.forEach(function (c) { if (c) f.appendChild(c); });
    return f;
  }
  function clear() { while (root.firstChild) root.removeChild(root.firstChild); }

  function badge(sev) {
    if (!sev || !SEV[sev]) return null;
    return el('span', { class: 'cker-badge cker-badge--' + sev, text: SEV[sev] });
  }

  function setHash(h) {
    if (('#' + h) !== location.hash) location.hash = h;   // triggers hashchange -> render
    else render();
  }

  /* ---------- data ---------- */
  function load() {
    if (!cfg.src) { showError(); return; }
    fetch(cfg.src, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        DATA = json;
        json.categories.forEach(function (c) { catById[c.id] = c; byCat[c.id] = []; });
        json.entries.forEach(function (e) {
          byId[e.id] = e;
          if (byCat[e.category]) byCat[e.category].push(e);
        });
        /* 2026-09-15 (Mariya: "Critical first isn't built ... sort Critical to the
           top within each category"). One sort key: critical, then common, then
           cosmetic. Stable, so master order holds within a severity. The landing
           page promises flagged-first cases; this is what makes that true. */
        var SEV_RANK = { critical: 0, common: 1, cosmetic: 2 };
        function sevRank(e) { var r = SEV_RANK[e.severity]; return r == null ? 1 : r; }
        Object.keys(byCat).forEach(function (cid) {
          byCat[cid] = byCat[cid]
            .map(function (e, i) { return { e: e, i: i }; })
            .sort(function (a, b) { return (sevRank(a.e) - sevRank(b.e)) || (a.i - b.i); })
            .map(function (x) { return x.e; });
        });
        render();
      })
      .catch(showError);
  }

  function showError() {
    clear();
    root.appendChild(el('div', { class: 'cker-app__error' }, [
      el('p', { text: 'the tool couldn’t load just now. every symptom and fix is listed just below.' }),
      el('a', { href: '#cker-index', class: 'ld-btn ld-btn--secondary', text: 'Browse all symptoms' })
    ]));
  }

  /* ---------- routing ---------- */
  function route() {
    var h = decodeURIComponent(location.hash.replace(/^#/, ''));
    if (!h || h === 'cker-index') return { view: 'home' };
    if (catById[h]) return { view: 'category', cat: h };
    if (byId[h]) return { view: 'entry', id: h };
    return { view: 'home' };
  }

  /* ---------- wide (1200px+, 2026-10-11, design canvas "Toolkit app: Cake ER") ----------
     Three columns at once: search + categories | the symptoms in the open
     category | the diagnosis. Each column is drawn by the SAME view functions
     as the phone (root is pointed at the column, then restored), so what a
     tier can see, and every word of it, is unchanged. */
  var MQW = window.matchMedia ? window.matchMedia('(min-width: 1200px)') : null;
  function isWide() { return !!(MQW && MQW.matches); }
  var mainRoot = root;
  function parentOf(entry) {
    for (var i = 0; i < DATA.entries.length; i++) {
      var p = DATA.entries[i];
      if (p.clarifier && (p.clarifier.yes === entry.id || p.clarifier.no === entry.id)) return p;
    }
    return null;
  }
  function renderWide(r) {
    var entry = r.view === 'entry' ? byId[r.id] : null;
    var catId = r.view === 'category' ? r.cat : (entry ? entry.category : (DATA.categories[0] && DATA.categories[0].id));
    var left = el('div', { class: 'cker-w__col cker-w__find' });
    var mid = el('div', { class: 'cker-w__col cker-w__list' });
    var right = el('div', { class: 'cker-w__col cker-w__card' });
    mainRoot.appendChild(el('div', { class: 'cker-w' }, [left, mid, right]));
    try {
      root = left; renderHome();
      root = mid; if (catId && catById[catId]) renderCategory(catId);
      root = right;
      if (entry) renderEntry(entry);
      else right.appendChild(el('div', { class: 'cker-w__empty' }, [
        el('p', { class: 'cker-eyebrow', text: 'Diagnosis' }),
        el('p', { text: 'pick a symptom and the diagnosis opens here.' })
      ]));
    } finally { root = mainRoot; }
    /* mark where she is: the open category, the open symptom */
    var cats = left.querySelectorAll('.cker-cat');
    DATA.categories.forEach(function (c, i) { if (c.id === catId && cats[i]) cats[i].classList.add('is-on'); });
    if (entry) {
      var shownAs = parentOf(entry) || entry;
      var chips = mid.querySelectorAll('.cker-chip');
      for (var k = 0; k < chips.length; k++) {
        if ((chips[k].textContent || '').indexOf(shownAs.symptom) === 0) chips[k].classList.add('is-on');
      }
    }
  }

  function render() {
    if (!DATA) return;
    var r = route();
    clear();
    if (isWide()) { renderWide(r); return; }
    if (r.view === 'home') renderHome();
    else if (r.view === 'category') renderCategory(r.cat);
    else renderEntry(byId[r.id]);
  }

  /* ---------- one symptom chip, used by categories and search ---------- */
  function symptomChip(e, withCrumb) {
    var lockedA = e.access === 'academy' && cfg.tier !== 'academy';
    var locked = lockedA || (e.access === 'members' && !isPremium);
    var left = el('span', {});
    if (withCrumb) {
      var c = catById[e.category];
      if (c) left.appendChild(el('span', { class: 'cker-chip__crumb', text: c.label }));
    }
    left.appendChild(document.createTextNode(e.symptom + ' '));
    var b = badge(e.severity);
    if (b) left.appendChild(b);
    return el('button', {
      class: 'cker-chip', type: 'button',
      onclick: function () { setHash(e.id); }
    }, [
      left,
      locked ? el('span', { class: 'cker-chip__lock', text: lockedA ? 'Academy' : 'Pro' })
             : el('span', { class: 'cker-chip__arrow', text: '→' })
    ]);
  }

  /* ---------- search: every word must land somewhere ----------
     Symptom text scores above keywords (the merge gave every entry a
     keywords array; older data without them still searches by symptom). */
  /* "cracked" must find "cracking": try each token as typed, then with the
     common English tail stripped, so tense never hides a rescue. */
  function stem(t) {
    var s = t.replace(/(ing|ed|es|s)$/, '');
    return s.length >= 3 ? s : t;
  }
  function tokenPoints(tok, s, kws) {
    var variants = [tok];
    if (stem(tok) !== tok) variants.push(stem(tok));
    for (var v = 0; v < variants.length; v++) {
      var t = variants[v];
      if (s.indexOf(t) === 0) return 3;
      if (s.indexOf(t) > -1) return 2;
      for (var j = 0; j < kws.length; j++) {
        if (kws[j].indexOf(t) === 0) return 1;
      }
    }
    return 0;
  }
  /* Strict pass first (every word lands somewhere); if that finds nothing
     for a multi-word query, fall back to closest matches (any word) —
     "cracked fondant" should surface the tearing-fondant rescue, not a
     dead end. Returns { list, partial }. */
  function searchEntries(q) {
    var toks = q.toLowerCase().split(/\s+/).filter(function (t) { return t.length > 1; });
    if (!toks.length) return null;
    function pass(requireAll) {
      var scored = [];
      DATA.entries.forEach(function (e) {
        var s = e.symptom.toLowerCase();
        var kws = (e.keywords || []).map(function (k) { return String(k).toLowerCase(); });
        var total = 0, missed = false;
        for (var i = 0; i < toks.length; i++) {
          var pts = tokenPoints(toks[i], s, kws);
          if (!pts) missed = true;
          total += pts;
        }
        if (total && (!requireAll || !missed)) scored.push({ e: e, total: total });
      });
      scored.sort(function (a, b) { return b.total - a.total; });
      return scored.map(function (x) { return x.e; });
    }
    var strict = pass(true);
    if (strict.length || toks.length < 2) return { list: strict, partial: false };
    return { list: pass(false), partial: true };
  }

  var lastQuery = '';   // survives entry visits — panic users bounce back
  /* Seed the search from an incoming ?symptom= (or ?q=) so the Learn hub's
     embedded search box lands here with results already filtered, in one
     submission (Nav IA brief §3.3/AC5). renderHome pre-fills + applies. */
  (function () {
    try {
      var qs = location.search.replace(/^\?/, '').split('&');
      for (var i = 0; i < qs.length; i++) {
        var kv = qs[i].split('=');
        if (kv[0] === 'symptom' || kv[0] === 'q') {
          var v = decodeURIComponent((kv[1] || '').replace(/\+/g, ' ')).trim();
          if (v) { lastQuery = v; break; }
        }
      }
    } catch (e) { /* no-op */ }
  })();

  /* ---------- view: search + category tiles ---------- */
  function renderHome() {
    root.appendChild(el('h2', { class: 'cker-step-title', text: 'what’s going wrong?' }));

    var input = el('input', {
      class: 'cker-search__input', type: 'search', autocomplete: 'off',
      /* r108 (Mariya, 2026-08-25): the placeholder ends at “soupy” — the
         three-example version was cut off mid-word on a phone, which reads
         as a broken field rather than a hint. */
      placeholder: 'type what you’re seeing. like “soupy”',
      'aria-label': 'Search all symptoms'
    });
    var results = el('div', { class: 'cker-search__results', 'aria-live': 'polite' });
    root.appendChild(el('div', { class: 'cker-search' }, [input]));
    root.appendChild(results);

    var browseSub = el('p', { class: 'cker-step-sub', text: 'or browse by where it’s going wrong:' });
    root.appendChild(browseSub);
    var cats = el('div', { class: 'cker-cats' }, DATA.categories.map(function (c) {
      var n = (byCat[c.id] || []).length;
      return el('button', {
        class: 'cker-cat', type: 'button',
        onclick: function () { setHash(c.id); }
      }, [
        el('span', { class: 'cker-cat__name', text: c.label }),
        el('span', { class: 'cker-cat__note', text: c.note || '' }),
        el('span', { class: 'cker-cat__count', text: n + (n === 1 ? ' symptom' : ' symptoms') })
      ]);
    }));
    root.appendChild(cats);

    var matches = null;
    function apply() {
      lastQuery = input.value;
      var found = input.value.trim().length >= 2 ? searchEntries(input.value) : null;
      matches = found ? found.list : null;
      while (results.firstChild) results.removeChild(results.firstChild);
      if (matches === null) {
        cats.style.display = ''; browseSub.style.display = '';
        return;
      }
      if (!matches.length) {
        results.appendChild(el('p', { class: 'cker-search__none', text: 'nothing matches “' + input.value.trim() + '”. the categories below have every symptom in the library.' }));
        cats.style.display = ''; browseSub.style.display = '';
        return;
      }
      cats.style.display = 'none'; browseSub.style.display = 'none';
      results.appendChild(el('p', {
        class: 'cker-search__count',
        text: found.partial
          ? 'no exact match. the closest ones:'
          : matches.length + (matches.length === 1 ? ' match' : ' matches')
      }));
      results.appendChild(el('div', { class: 'cker-chips' }, matches.map(function (e) { return symptomChip(e, true); })));
    }
    var deb = null;
    input.addEventListener('input', function () {
      clearTimeout(deb); deb = setTimeout(apply, 120);
    });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        if (matches && matches.length) setHash(matches[0].id);
      }
    });
    if (lastQuery) { input.value = lastQuery; apply(); }
  }

  /* ---------- view: symptom chips ---------- */
  function renderCategory(catId) {
    var cat = catById[catId];
    root.appendChild(el('button', {
      class: 'cker-back', type: 'button', text: 'All categories',
      onclick: function () { setHash(''); }
    }));
    root.appendChild(el('h2', { class: 'cker-step-title', text: cat.label }));
    root.appendChild(el('p', { class: 'cker-step-sub', text: 'What are you seeing?' }));

    // hide clarifier target entries from the picker — reached via their router
    var targets = {};
    DATA.entries.forEach(function (e) {
      if (e.clarifier) { targets[e.clarifier.yes] = true; targets[e.clarifier.no] = true; }
    });

    root.appendChild(el('div', { class: 'cker-chips' },
      (byCat[catId] || []).filter(function (e) { return !targets[e.id]; }).map(function (e) {
        return symptomChip(e, false);
      })));
  }

  /* ---------- view: clarifier ---------- */
  function renderClarifier(entry) {
    root.appendChild(el('div', { class: 'cker-clarifier' }, [
      el('p', { class: 'cker-eyebrow', text: 'One quick question' }),
      el('h3', { text: entry.clarifier.question }),
      el('p', { text: 'This tells us which rescue you need.' }),
      el('div', { class: 'cker-clarifier__btns' }, [
        el('button', { class: 'ld-btn ld-btn--primary', type: 'button', text: 'Yes',
          onclick: function () { setHash(entry.clarifier.yes); } }),
        el('button', { class: 'ld-btn ld-btn--secondary', type: 'button', text: 'No',
          onclick: function () { setHash(entry.clarifier.no); } })
      ])
    ]));
  }

  /* ---------- view: diagnosis card ---------- */
  function renderEntry(entry) {
    var cat = catById[entry.category];
    root.appendChild(el('button', {
      class: 'cker-back', type: 'button', text: cat ? cat.label : 'Back',
      onclick: function () { setHash(entry.category); }
    }));

    if (entry.clarifier) { renderClarifier(entry); return; }

    /* teaser-only data shape: a members entry locked for this tier, or an
       academy entry that carries a teaser (locked for public AND pro) */
    var isPremiumOnly = (entry.access === 'members' || entry.access === 'academy') && !entry.diagnosis;
    var card = el('article', { class: 'cker-card' + (isPremiumOnly ? ' cker-card--prolock' : '') });

    card.appendChild(el('div', { class: 'cker-card__meta' }, [
      el('span', { class: 'cker-card__cat', text: cat ? cat.label : '' }),
      badge(entry.severity)
    ]));
    card.appendChild(el('h2', { class: 'cker-card__symptom', text: entry.symptom }));

    if (isPremiumOnly) {
      var aca = entry.access === 'academy';
      card.appendChild(el('p', { class: 'cker-teaser', text: entry.teaser || '' }));
      card.appendChild(el('section', { class: 'cker-locked' }, [
        lockedPanel(aca
          ? 'The diagnosis, the fix and the tip are taught in the Academy.'
          : 'The diagnosis, the fix and the tip are in Toolkit Pro.', aca)
      ]));
    } else {
      /* Every field is feature-detected: the public shape decides what
         renders, so this works against old AND new data. Present parts
         render top-down; everything the public shape withholds is
         collected into ONE locked panel at the end. */
      /* ===== S-6 (Simplification brief) + Mariya's paywall call, 2026-08-03
         "Diagnosis-before-fix is the wrong order for a tool used at 11pm."
         True — for someone who HAS the fix. Her objection was equally true:
         the fix is deliberately withheld on 53 of 70 entries, and on those
         the diagnosis IS the free product that earns the purchase.

         So the order follows the PAYLOAD, not a blanket rule:
           fix present  -> Fix now, then what/why folded beneath it
           fix withheld -> diagnosis first, exactly as before, then the lock
         Nothing about the gating moves; `fix_steps` is simply absent from a
         locked payload, so `hasFix` is the honest test. ===== */
      var hasFix = !!(entry.fix_steps && entry.fix_steps.length);
      /* 8 entries in the master carry a `why` that is character-identical to
         their `diagnosis` (verified 2026-08-03; a 9th is >0.85). Rendering
         both prints the same paragraph twice. The other ~60 are genuinely
         different — median similarity 0.38 — so this dedupes by COMPARISON
         at render time rather than by deleting a field, and it heals itself
         if she edits either one. */
      var dgn = (entry.diagnosis || '').trim();
      var why = (entry.why || '').trim();
      var whyIsEcho = !!(dgn && why && dgn.toLowerCase() === why.toLowerCase());

      function diagnosisSection() {
        if (!dgn) return null;
        return section('what’s happening', [el('p', { text: entry.diagnosis })]);
      }
      function fixSection() {
        if (!hasFix) return null;
        return section('the fix, right now', [
          el('ol', {}, entry.fix_steps.map(function (s) { return el('li', { text: s }); }))
        ]);
      }
      function whySection() {
        if (!why || whyIsEcho) return null;
        /* 2026-09-15 (Mariya): "why" is free content and one paragraph, so it
           shows OPEN under a hairline heading now, not tucked behind a bordered
           fold. Same section grammar as the diagnosis. */
        return section('why it happened', [el('p', { text: entry.why })]);
      }

      var ordered = hasFix
        /* the fix leads; the reading that explains it follows */
        ? [fixSection(), diagnosisSection(), whySection()]
        /* locked: the free diagnosis leads, the lock closes */
        : [diagnosisSection(), whySection()];
      ordered.forEach(function (n) { if (n) card.appendChild(n); });
      if (entry.tip) {
        card.appendChild(section('LAYER’D TIP', [
          el('div', { class: 'ld-callout ld-callout--note' }, [
            el('strong', { class: 'ld-callout__label', text: 'LAYER’D TIP' }),
            document.createTextNode(entry.tip)
          ])
        ], true));
      }
      var locked = [];
      if (!entry.fix_steps) locked.push('fix');
      if (!entry.why) locked.push('why');
      if (!entry.tip) locked.push('tip');
      if (locked.length) card.appendChild(lockedBlock(locked, entry.access === 'academy'));
    }

    card.appendChild(cardFooter(entry));
    root.appendChild(card);
    root.appendChild(relatedRow(entry));
    // deep links land mid-page; bring the card into view
    if (root.getBoundingClientRect().top < 0 || root.getBoundingClientRect().top > window.innerHeight * 0.6) {
      ldNav(root);
    }
  }

  function section(title, children, plainTitle) {
    var kids = plainTitle ? [] : [el('h3', { text: title })];
    return el('section', {}, kids.concat(children));
  }

  var LOCK_SVG = '<svg class="cker-locked__lock" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6V5a4 4 0 1 1 8 0v1h1.25c.41 0 .75.34.75.75v7.5c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.75-.75v-7.5c0-.41.34-.75.75-.75H4Zm2 0h4V5a2 2 0 1 0-4 0v1Z"/></svg>';

  /* Compose the "what's locked" phrase from the fields the public shape
     withheld, so the single combined panel names them all. */
  function lockedLabel(fields) {
    var parts = fields.map(function (f) {
      return f === 'fix' ? 'the fix'
           : f === 'why' ? 'why it happened'
           : 'the prevention tip';
    });
    var joined = parts.length === 1 ? parts[0]
      : parts.length === 2 ? parts[0] + ' and ' + parts[1]
      : parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1];
    return joined.charAt(0).toUpperCase() + joined.slice(1);
  }

  function lockedBlock(fields, academy) {
    var verb = fields.length === 1 ? ' is ' : ' are ';
    var line = lockedLabel(fields) + verb + (academy ? 'taught in the Academy.' : 'in Toolkit Pro.');
    return el('section', { class: 'cker-locked' }, [ lockedPanel(line, academy) ]);
  }

  /* 2026-09-15 (Mariya: "Pro is sold four ways on one card ... One veil, one
     line, one door"). The veil is exactly that: the lock eyebrow, one line
     naming what's behind it, and one gold door. Gone are the price button, the
     second Academy button, the login line, the cancel-anytime sentence and the
     $100-off sentence — that was the product page reprinted on every symptom.
     academy-access entries send their door to the Academy (Pro can't unlock
     them); split/members locks send it to Toolkit Pro. The one line kept is for
     a paying Pro member who still meets a lock on an Academy-only rescue — so
     they know their Pro isn't broken, it just doesn't reach this one. */
  function lockedPanel(line, academy) {
    var doorHref = academy ? (cfg.academyUrl || '#learn-waitlist') : (cfg.proUrl || '#learn-waitlist');
    var doorText = academy
      ? (cfg.mode === 'live' ? 'Enroll →' : 'Join the waitlist →')
      : 'Unlock →';
    var kids = [
      el('p', { class: 'cker-locked__eyebrow', html: LOCK_SVG + (academy ? 'LAYER’D Academy' : 'LAYER’D Toolkit Pro') }),
      el('p', { class: 'cker-locked__line', text: line }),
      el('a', { class: 'cker-locked__door', href: doorHref, text: doorText })
    ];
    if (academy && cfg.tier === 'pro') {
      kids.push(el('p', { class: 'cker-locked__note', text:
        'this one goes deeper than the Toolkit. i teach it inside the Academy, so Pro doesn’t include it.' }));
    }
    return el('div', { class: 'cker-locked__veil' }, kids);
  }

  function legacyShare(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.left = '-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) { /* nothing more we can do */ }
    document.body.removeChild(ta);
  }

  /* Does this entry show a locked veil for the current tier? If it does,
     the veil already carries the purchase CTA, so the footer must NOT
     repeat it (that was the double-stack, and on academy entries it wrongly
     offered Toolkit Pro for content Pro can't unlock). */
  function hasVeil(entry) {
    if (entry.clarifier) return false;
    if (entry.access === 'academy') return cfg.tier !== 'academy';
    if (entry.access === 'members') return !isPremium;
    if (entry.access === 'split') return !isPremium;
    return false; // free
  }

  function cardFooter(entry) {
    var f = el('div', { class: 'cker-card__footer' });
    if (entry.academy_chapter) {
      var p = el('p', { class: 'cker-card__chapter' });
      if (isPremium) {
        p.appendChild(document.createTextNode('i walk through this in full in '));
        p.appendChild(el('strong', { text: entry.academy_chapter }));
        p.appendChild(document.createTextNode(' of the Academy.'));
      } else {
        /* 2026-09-15 (Mariya): "i show the whole thing on camera" described a
           course that opens in winter. One quiet sentence, and stop. */
        p.appendChild(document.createTextNode('this one’s '));
        p.appendChild(el('strong', { text: entry.academy_chapter }));
        p.appendChild(document.createTextNode(', taught in the Academy.'));
      }
      f.appendChild(p);
    }
    var actions = el('div', { class: 'cker-card__actions' });
    /* 2026-09-15 (Mariya: "the five free cards carry purchase buttons ... let the
       card end on the fix, the tip, and 'Send to a baker friend'"). Nothing on a
       free card is locked, so it no longer ends on "Unlock Toolkit Pro" / "See
       the Academy". A visitor who just got a full rescue for free is handed the
       share link instead — the right call to action at that moment. Locked cards
       still get their single door from the veil. */
    if (entry.id === 'structure-dowel-count' && cfg.dowelCalcUrl) {
      actions.appendChild(el('a', { class: 'ld-btn ld-btn--secondary', href: cfg.dowelCalcUrl, text: 'Open the dowel calculator' }));
    }
    /* Copy only what's actually on the card. Teaser-only entries have
       nothing to copy, so no button. */
    var footHasFix = !!(entry.fix_steps && entry.fix_steps.length);
    if (footHasFix || entry.diagnosis) {
      actions.appendChild(el('button', {
        class: 'cker-copy', type: 'button', text: footHasFix ? 'Copy these steps' : 'Copy this',
        onclick: function (ev) { copyEntry(entry, ev.currentTarget); }
      }));
    }
    /* Every rescue is a shareable deep link — panic travels by group
       chat, and the friend lands on this exact diagnosis. */
    actions.appendChild(el('button', {
      class: 'cker-copy', type: 'button', text: 'Send to a baker friend',
      'aria-label': 'Copy a link to this rescue',
      onclick: function (ev) {
        var b = ev.currentTarget;
        var url = location.origin + location.pathname + '#' + entry.id;
        function done() {
          b.textContent = 'link copied, send it';
          setTimeout(function () { b.textContent = 'Send to a baker friend'; }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { legacyShare(url); done(); });
        } else { legacyShare(url); done(); }
      }
    }));
    f.appendChild(actions);
    return f;
  }

  function relatedRow(entry) {
    var rel = (entry.related || []).map(function (id) { return byId[id]; }).filter(Boolean);
    if (!rel.length) return el('div');
    return el('div', { class: 'cker-related' }, [
      el('h4', { text: 'bakers with this also checked' }),
      el('div', { class: 'cker-related__row' }, rel.map(function (r) {
        return el('a', {
          href: '#' + r.id, text: r.symptom,
          onclick: function (e) { e.preventDefault(); setHash(r.id); }
        });
      }))
    ]);
  }

  /* ---------- copy: plain text of what the visitor can see ---------- */
  function copyEntry(entry, btn) {
    var lines = ['CAKE ER by LAYER’D Cakes', entry.symptom.toUpperCase(), ''];
    /* S-6: the pasted copy follows the same order the card does — a fix
       texted to a panicking friend should open with the fix. */
    var cHasFix = !!(entry.fix_steps && entry.fix_steps.length);
    var cDgn = (entry.diagnosis || '').trim();
    var cWhy = (entry.why || '').trim();
    var cEcho = !!(cDgn && cWhy && cDgn.toLowerCase() === cWhy.toLowerCase());
    if (cHasFix) {
      lines.push('THE FIX, RIGHT NOW');
      entry.fix_steps.forEach(function (s, i) { lines.push((i + 1) + '. ' + s); });
      lines.push('');
    }
    if (cDgn) lines.push('WHAT’S HAPPENING', entry.diagnosis, '');
    if (cWhy && !cEcho) lines.push('WHY IT HAPPENED', entry.why, '');
    if (entry.tip) lines.push('LAYER’D TIP', entry.tip, '');
    if (entry.teaser && !entry.diagnosis) lines.push(entry.teaser, '');
    lines.push('Full guide: ' + location.href.split('#')[0] + '#' + entry.id);
    var text = lines.join('\n');

    function done(ok) {
      var old = btn.textContent;
      btn.textContent = ok ? 'Copied ✓' : 'Couldn’t copy';
      setTimeout(function () { btn.textContent = old; }, 1800);
    }
    function legacyCopy() {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.left = '-9999px';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      done(ok);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { done(true); }, legacyCopy);
    } else {
      legacyCopy();
    }
  }

  /* ---------- go ---------- */
  window.addEventListener('hashchange', render);
  if (MQW && MQW.addEventListener) MQW.addEventListener('change', render);
  else if (MQW && MQW.addListener) MQW.addListener(render);
  // index links (server-rendered) already use #entry-id hashes — hashchange handles them.
  load();
})();

/* ============================================================
   r108 (Mariya, 2026-08-25) — THE FULL LIBRARY FOLDS.
   Seventy symptoms rendered open was one unbroken wall of text
   under the tool. Each entry now starts closed and opens on tap.

   Progressive enhancement on purpose: the page still SHIPS every
   word in the markup (this only hides it after load), so search
   engines and a no-JS visitor keep the whole library — the SEO
   page stays an SEO page. A "Open all" control restores find-in-
   page, and a #idx-… deep link opens its own entry.
   ============================================================ */
(function ckerIndexFolds() {
  var index = document.getElementById('cker-index');
  if (!index) return;
  var cats = [].slice.call(index.querySelectorAll('.cker-index__cat'));
  if (!cats.length) return;

  /* 2026-09-15 (Mariya: "collapse it to six closed category folds and drop
     Open all"). The index was seventy per-entry accordion rows plus an
     "Open all 70" control — a second copy of the whole library that, on a
     phone, read as the page continuing forever. It folds by CATEGORY now:
     six heads, all closed, each opening to its symptoms. Still progressive
     enhancement — every word ships in the markup for crawlers and no-JS
     visitors; this only hides it after load. */
  var folds = [];
  cats.forEach(function (cat, i) {
    var title = cat.querySelector('.cker-index__cat-title');
    if (!title) return;

    var body = document.createElement('div');
    body.className = 'cker-index__catbody';
    body.id = 'cker-idxcat-' + i;
    body.hidden = true;
    /* everything after the title becomes the fold body */
    [].slice.call(cat.childNodes).forEach(function (n) {
      if (n === title) return;
      body.appendChild(n);
    });
    var count = body.querySelectorAll('.cker-index__entry').length;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cker-index__cattoggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', body.id);
    var name = document.createElement('span');
    name.className = 'cker-index__catname';
    name.textContent = title.textContent.trim();
    btn.appendChild(name);
    var cnt = document.createElement('span');
    cnt.className = 'cker-index__catcount';
    cnt.textContent = count + (count === 1 ? ' symptom' : ' symptoms');
    btn.appendChild(cnt);
    var x = document.createElement('span');
    x.className = 'cker-index__x';
    x.setAttribute('aria-hidden', 'true');
    x.textContent = '▾';
    btn.appendChild(x);

    while (title.firstChild) title.removeChild(title.firstChild);
    title.appendChild(btn);                       /* heading > button: the accordion pattern */
    cat.appendChild(body);

    function setOpen(openNow) {
      body.hidden = !openNow;
      btn.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      cat.classList.toggle('is-open', openNow);
    }
    btn.addEventListener('click', function () { setOpen(body.hidden); });
    folds.push({ body: body, setOpen: setOpen });
  });

  /* a deep link to an entry (#id from the tool, or #idx-id) opens its
     category fold so the target is on screen */
  function openFromHash() {
    var h = (location.hash || '').replace('#', '');
    if (!h) return;
    var art = document.getElementById('idx-' + h) || document.getElementById(h);
    if (!art) return;
    folds.forEach(function (f) { if (f.body.contains(art) && f.body.hidden) f.setOpen(true); });
  }
  window.addEventListener('hashchange', openFromHash);
  openFromHash();
})();
